import { DatesResponse } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/getDates';
import { TimeFrequenciesResponse, TimeFrequency } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/getTimeFrequencies';
import { ModelResponse, Model } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/model';
import { VariableResponse, Variable } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/variable';
import { MemberResponse, Member } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/member';
import { ListTrackingForecastPreferencesResponse } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/listPreferences';
import { TrackingForecastPreference } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/preference';

export const transformGetTimeFrequencies = (
  response: TimeFrequenciesResponse,
): TimeFrequency[] => response.data.map((item) => ({
  label: item.label,
  value: item.nome,
}));

export const transformGetModels = (
  response: ModelResponse,
): Model[] => (
  response.data.map((model) => ({
    id: model.id,
    value: model.nome,
    label: model.label,
  }))
);

export const transformGetVariables = (
  response: VariableResponse,
): Variable[] => (
  response.data.map((variable) => ({
    value: variable.nome,
    label: variable.label,
  }))
);

export const transformGetMembers = (
  response: MemberResponse,
): Member[] => (
  response.data.map((member) => ({
    id: member.id,
    label: member.label,
  }))
);

export const transformGetDates = (response: DatesResponse): string[] => response.data;

export const transformListPreferences = (
  response: ListTrackingForecastPreferencesResponse,
): TrackingForecastPreference[] => response.data.map((preference) => ({
  id: preference.id,
  name: preference.name,
  submenu: preference.json_p.submenu,
  params: {
    ...(({ submenu, ...rest }) => rest)(preference.json_p),
  },
}));
